export default class HomeVideo {
  constructor(root) {
    if (root && !Modernizr.touchevents) {
      this.root = root;
      this.init();
    }
  }

  init() {
    const video = this.root.querySelector('video');
    const source = document.createElement('source');

    source.setAttribute('src', video.dataset.src);
    source.setAttribute('type', video.dataset.type);

    video.appendChild(source);
  }
}
